import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { FAQs } from '@/components/seo';
export function FaqList() {
  const $ = _c(41);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["referral"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("faq.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-10 lg:mb-16" anchorKey="faq.title" id="faq">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("faq.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("faq.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      question: t3,
      answer: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("faq.items.2.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("faq.items.2.text");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = {
      question: t6,
      answer: t7
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("faq.items.3.title");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("faq.items.3.text");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = {
      question: t9,
      answer: t10
    };
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("faq.items.4.title");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("faq.items.4.text");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = {
      question: t12,
      answer: t13
    };
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t14 || $[35] !== t5 || $[36] !== t8) {
    t15 = <div className="flex flex-col gap-2"><FAQs hideButton={true} className="m-0!" data={[t5, t8, t11, t14]} /></div>;
    $[33] = t11;
    $[34] = t14;
    $[35] = t5;
    $[36] = t8;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== t2) {
    t16 = <div className="relative z-10 mx-auto flex max-w-192 flex-col gap-20 lg:gap-40"><div>{t2}{t15}</div></div>;
    $[38] = t15;
    $[39] = t2;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
}